const revisedPaymentSchedulesReport = {
  label: "Revised Payment Schedules Report",
  name: "revisedPaymentSchedulesReport",
  parameters: [
    {
      name: "bondcall",
      label: "BondCall",
      type: "date",
    },
    {
      name: "program",
      label: "Program",
      type: "dbfield",
      db: ["hero", "data"],
      table: "Program",
      keyField: "ProgramAssociatedId",
      valueField: "ProgramAssociatedId",
      fields: ["Program.ProgramAssociatedId"],
      distinct: true,
      where: {
        ProgramAssociatedId: {
          null: false,
        },
      },
      sort: {
        ProgramAssociatedId: "asc",
      },
    },
  ],
};

export default revisedPaymentSchedulesReport;
